export const getReturn = state => state.returnContent.returnData;
export const getLoading =state => state.returnContent.isLoading;
export const getUpdatedStatus =state => state.returnContent.updatedStatus;
export const getIsTicketLoading = state => state.returnContent.isTicketLoading;
export const getTicketData = state => state.returnContent.ticketData;
